module.exports = __webpack_public_path__ + "img/10.479bd7a5.png";